
export default {
  id: '#section-6',

  name: '이벤트',

  linkUrl: 'https://lineage.plaync.com/events/2020/200812_lancer/signature',

  linkBlank: true,

  enterStart() {
    mountAnimation.play();
  },

  leaveEnd() {
    mountAnimation.seek(0).pause();
  }
};



// WEBPACK FOOTER //
// ./src/js/pc/section-6.js